// import apiFun from "@/util/api.js";
import wx from 'weixin-js-sdk';
export default {

    weizhi(thata) {
        var urls = window.location.href;

        let urlHost = process.env.API_HOST
        console.log(process.env.API_HOST)
        let url = urlHost + 'hldhd/public/index.php/ticket/Ticket/share'
        let info = {
            url: urls
        }
        apiFun.saveJcInfo(url, info).then((res) => {
            console.log(res);

            var jssdk = res.data.jssdk
            wx.config({
                debug: jssdk.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: jssdk.appId, // 必填，公众号的唯一标识
                timestamp: jssdk.timestamp, // 必填，生成签名的时间戳
                nonceStr: jssdk.nonceStr, // 必填，生成签名的随机串
                signature: jssdk.signature, // 必填，签名，见附录1
                jsApiList: jssdk.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.ready(() => {
                // wx.getLocation({
                //   debug: false,
                //   type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                //   success: function (res) {
                //     thata.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                //     thata.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                //   },
                // });
                //分享到朋友圈

                wx.onMenuShareTimeline({
                    title: res.data.title,   // 分享时的标题
                    desc: res.data.content,  //内容
                    link: res.data.url,     // 分享时的链接
                    imgUrl: res.data.bg,    // 分享时的图标
                    success: function () {
                        console.log("分享成功");
                    },
                    cancel: function () {
                        console.log("取消分享");
                    }
                });
                //分享给朋友
                wx.onMenuShareAppMessage({
                    title: res.data.title,
                    desc: res.data.content,
                    link: res.data.url,
                    imgUrl: res.data.bg,
                    type: '',
                    dataUrl: '',
                    success: function () {
                        console.log("分享成功");
                    },
                    cancel: function () {
                        console.log("取消分享");
                    }
                });
            });
        })
    },
    mounted(that) {

        that.nolond();

    },

    getUrlCode() { // 截取url中的code方法
        var url = location.search
        this.winUrl = url
        var theRequest = new Object()
        if (url.indexOf("?") != -1) {
            var str = url.substr(1)
            var strs = str.split("&")
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
            }
        }
        return theRequest
    },
    deleteParams(name) {

        var str = location.href
        var num = str.indexOf("#");
        str = str.substr(num + 1);
        console.log(str.slice(1))

        var loca = window.location;
        var baseUrl = loca.origin + loca.pathname + "?";
        var query = loca.search.substr(1);
        if (query.indexOf(name) > -1) {



            var obj = {}
            var arr = query.split("&");
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].split("=");
                obj[arr[i][0]] = arr[i][1];
            };
            delete obj[name];
            localStorage.setItem("params", JSON.stringify(obj));
            var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
            return url + '#/' + str.slice(1)
        } else {
            var obj = {}
            var arr = query.split("&");
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].split("=");
                obj[arr[i][0]] = arr[i][1];
            };
            localStorage.setItem("params", JSON.stringify(obj));
        }

    },

}


// WEBPACK FOOTER //
// ./src/util/utils.js